import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MastHeadSectionComponent = _resolveComponent("MastHeadSectionComponent")!
  const _component_ProductsSectionComponent = _resolveComponent("ProductsSectionComponent")!
  const _component_AboutSectionComponent = _resolveComponent("AboutSectionComponent")!
  const _component_ContactSectionComponent = _resolveComponent("ContactSectionComponent")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_MastHeadSectionComponent),
    _createVNode(_component_ProductsSectionComponent),
    _createVNode(_component_AboutSectionComponent),
    _createVNode(_component_ContactSectionComponent)
  ]))
}